import { rootApi } from "..";
import { leaveService } from "../../../Api/Services/LeaveService";
import {
  IApplyLeaveFormData,
  ILeaveUserPayload,
} from "../../../features/leave/types";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

export const employeeLeaveEndpoints = [
  {
    name: "leaveList",
    type: "query",
    serviceFn: ({ activeYear, userId }: ILeaveUserPayload) =>
      leaveService.getLeaveDetails(activeYear, userId),
    tagType: "EmployeeLeaveInfo",
  },
  {
    name: "leaveTypesList",
    type: "query",
    serviceFn: (
      { activeYear, userId }: { activeYear?: string; userId?: number } // Payload Type
    ) => leaveService.getLeaveTypes({ activeYear, userId }),
    tagType: "EmployeeLeaveInfo",

  },
  {
    name: "compoffLeave",
    type: "query",
    serviceFn: (userId: number) => leaveService.getAvailableCompOffs(userId),
  },
  {
    name: "applyLeave",
    type: "mutation",
    serviceFn: (leaveFormData: IApplyLeaveFormData) =>
      leaveService.applyLeaveUser(leaveFormData),
    tagType: "EmployeeLeaveInfo",
  },
] as const;

export const employeeLeaveApi = rootApi.injectEndpoints({
  endpoints: (builder) => makeEndpoints(builder, employeeLeaveEndpoints),
});

export const {
  useLeaveListQuery,
  useCompoffLeaveQuery,
  useLazyCompoffLeaveQuery,
  useApplyLeaveMutation,
  useLeaveTypesListQuery,
} = employeeLeaveApi;
